// extracted by mini-css-extract-plugin
export default {"SampleDetailsPage":"SampleDetailsPage_SampleDetailsPage__8kC4Z"};